import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider, MutationCache } from '@tanstack/react-query';
import { AuthProvider } from '@/context/AuthContext';
import { BranchScopeProvider } from '@/context/BranchScopeContext';
import App from './App';
import './index.css';
import { toast } from 'react-toastify';

const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error: any) => {
      const msg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.data?.message ||
        error?.message ||
        'Произошла ошибка';
      toast.error(msg);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 0,
      retry: 1,
      refetchOnWindowFocus: true,
      refetchInterval: 30_000,   // Avto yangilash: 30 sekund
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BranchScopeProvider>
          <App />
        </BranchScopeProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
